import React from "react";
import axios from "axios";
import "moment/locale/es";
import PostulacionContainer from "./PostulacionContainer";
import { useParams } from "react-router-dom";
import PostulacionForm from "./PostulacionForm";
import {handleEdicionConcursoError} from "../../utils/errors";

const PostulacionEdit = (props) => {
  const { uuid, pop } = useParams();
  const [postulacion, setPostulacion] = React.useState({});
  const [loadingPostulacion, setLoadingPostulacion] = React.useState(true);

  React.useEffect(() => {
    let api_route = `/postulacion/${uuid}/`;

    axios
      .get(window.ENV.API_URL + api_route)
      .then((res) => {
        setPostulacion(res.data[0]);
        setLoadingPostulacion(false);
      })
      .catch((error) => handleEdicionConcursoError(error));
  }, []);

  if (loadingPostulacion) {
    return <PostulacionContainer noIntro />;
  }


  return (
    <PostulacionContainer noIntro>
      <h4 className="pb-3">
        Edición de Postulación
      </h4>

      <PostulacionForm
        concursoPk={postulacion.codigo_concurso}
        defaultData={postulacion}
        uuid={uuid}
        popUp={pop}
      />
    </PostulacionContainer>
  );
};

export default PostulacionEdit;
